module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bodyOil@3x_d3897a.png";